import axios from "axios";
import { useQuery } from "react-query";
import { getAuthHeader, getDbHeader } from "../utils/util";
import { API_ENDPOINT } from "../utils/constants";

const useTermsConditions = (token) => {
  return useQuery({
    queryKey: ["get-visitor-template-public", token],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}/event/get-visitor-template-public`,
        getAuthHeader(token)
      );
      return response.data;
    },
    enabled: !!token, // Prevent execution if id or token is missing
    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useTermsConditions;
